export default __webpack_public_path__ + "static/media/nettwerk-header.e1b4ed23.svg";